var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "email",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2979ff",
    d: "M16 18.06a5.53 5.53 0 0 1-3.64-1.36L2.53 8.18a1 1 0 1 1 1.31-1.51l9.86 8.52a3.55 3.55 0 0 0 4.63 0l9.94-8.44a1 1 0 1 1 1.29 1.52l-9.93 8.44A5.56 5.56 0 0 1 16 18.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M26.65 26.48H5.35a4.05 4.05 0 0 1-4-4.05V9.57a4.05 4.05 0 0 1 4-4.05h21.3a4.05 4.05 0 0 1 4.05 4.05v12.86a4.05 4.05 0 0 1-4.05 4.05Zm-21.3-19a2.05 2.05 0 0 0-2 2.05v12.9a2.05 2.05 0 0 0 2.05 2.05h21.3a2.05 2.05 0 0 0 2.05-2.05V9.57a2.05 2.05 0 0 0-2.05-2.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.76c31eb3ec24e55907b7fcebc1554d39.svg";
export { ForwardRef as ReactComponent };